import * as React from 'react';

import {setBodyId} from '../../../dom';
import {PageContainer, PageTitleBar} from '../../../ui/layout';
import {mountSettingsSidebar} from '../../../ui/setup/mount-settings-sidebar';
import {SetupPage} from '../../../ui/setup/setup-page';

type Props = {
    search: string;
    pathname: string;
};
/**
 * Wrapper for the sender addresses page that allows it to render as a complete
 * page outside of the setup context. We use this for the version in the marketing tab
 */
export function ActivityQuotasPageStandalone(props: Props) {
    setBodyId('');

    return (
        <PageContainer
            noPadding={true}
            title='Activity Quotas'
            pageTitleBar={
                <PageTitleBar
                    title='Activity quotas'
                    subheaderPrimaryText='Distribute your activity quotas throughout the year and amongst your team members.'
                />
            }
        >
            <SetupPage
                pageTitle='Activity Quotas'
                viewUrl={props.pathname}
                viewParams={props.search}
                onViewRendered={mountSettingsSidebar}
            />
        </PageContainer>
    );
}
